import React from 'react';
import PropTypes from 'prop-types';

function ThumbsUp({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.064 11.2L11.316 4c.647 0 1.267.253 1.724.703.458.45.715 1.06.715 1.697v3.2h4.6a1.648 1.648 0 011.246.55 1.591 1.591 0 01.38 1.29l-1.121 7.2c-.059.381-.256.73-.555.98-.298.249-.679.384-1.071.38h-9.17m0-8.8V20m0-8.8H5.626c-.431 0-.845.168-1.15.469-.305.3-.476.707-.476 1.13v5.6c0 .425.171.832.476 1.132.305.3.719.469 1.15.469h2.438"
      />
    </svg>
  );
}

ThumbsUp.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ThumbsUp;
